import { Injectable } from '@angular/core';

let kebabCase = require('lodash/kebabCase');

@Injectable()
export class HelperService {
  public static buildBemElementClass(
    bemPrefix: string,
    element: string,
  ): string {
    return `${bemPrefix}__${kebabCase(element)}`;
  }

  public static buildBemModifierClass(
    bemPrefix: string,
    modifier: string,
  ): string {
    return `${bemPrefix}--${kebabCase(modifier)}`;
  }
}
